
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#323334","d":"M.1 1.56V.43C.1.2.3.01.54.01h15.01c.23 0 .42.19.42.42v1.13c0 .23-.19.42-.42.42H.53a.42.42 0 01-.43-.42zM7.39 6.5h8.25c.2 0 .37-.19.37-.42V4.95c0-.24-.17-.43-.38-.43H7.38c-.21 0-.38.2-.38.43v1.13c0 .23.17.42.38.42zM.57 15.53h15c.24 0 .43-.19.43-.42v-1.13a.42.42 0 00-.42-.42H.56a.42.42 0 00-.43.42v1.13c0 .23.2.42.43.42zm6.8-4.51h8.25c.21 0 .38-.2.38-.43V9.46c0-.23-.17-.42-.38-.42H7.38c-.21 0-.38.19-.38.42v1.13c0 .24.17.43.38.43zM1 4.52h4a1 1 0 011 1v4.5a1 1 0 01-1 1H1a1 1 0 01-1-1v-4.5a1 1 0 011-1z"}})])
          )
        }
      }
    